import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { StarrySky } from './components/StarrySky';
import Header from './components/Header';
import ArticleView from './components/ArticleView';

function App() {
  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      console.log('Viewport height (vh):', vh); // Debugging log
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
  
    // Set height on load
    setViewportHeight();
  
    // Add multiple event listeners
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('scroll', setViewportHeight);
  
    return () => {
      // Clean up event listeners
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('scroll', setViewportHeight);
    };
  }, []);
  


  return (
    <Router>
      <Header />
     
        <Routes>
          <Route path="/" element={<StarrySky />} />
          <Route path="/article/:id" element={<ArticleView />} />
        </Routes>
    </Router>
  );
}

export default App;
